// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullscreen {\n  height: 90vh !important;\n}\n.tooltip {\n  /* TODO: remove this when the vuexy integration is ready*/\n  z-index: 53001;\n}\n", ""]);
// Exports
module.exports = exports;
